import { useMemo } from 'react';

import axios, { Axios } from 'axios';

import { oimApiConfig } from '../../../config';
import { useAuthorization } from '../../../utils/Api';
import { ScopeModel } from '../types';

export type CreateScopeParams = Partial<ScopeModel>;
export type UpdateScopeParams = Partial<ScopeModel>;
export type GetScopeParams = Pick<ScopeModel, 'appId' | 'scopeId'>;

class ScopesService {
  constructor(private readonly http: Axios) {}

  async getScope({ appId, scopeId }: GetScopeParams): Promise<ScopeModel> {
    const { data } = await this.http.get<ScopeModel>(this.buildUrl(appId, scopeId));

    return data;
  }

  async createScope({ appId, ...params }: CreateScopeParams): Promise<ScopeModel> {
    const { data } = await this.http.post<ScopeModel>(this.buildUrl(appId), params);

    return data;
  }

  async updateScope({ scopeId, appId, ...params }: UpdateScopeParams): Promise<ScopeModel> {
    const { data } = await this.http.patch<ScopeModel>(this.buildUrl(appId, scopeId), params);

    return data;
  }

  private buildUrl(appId?: string, scopeId?: string): string {
    let url = `apps/${appId}/scopes`;

    if (scopeId) {
      url += `/${scopeId}`;
    }

    return url;
  }
}

export const useScopesService = () => {
  const http = axios.create({
    baseURL: oimApiConfig.apiBaseUrl,
  });

  useAuthorization(http);

  return useMemo(() => new ScopesService(http), [http]);
};
